import cn from 'clsx'

import { type GraphicDivider as GraphicDividerType } from '../../../../../apps/benmax/src/types/sanity.types'

import ImageBox from '../../ImageBox/ImageBox'

import Diamond from '../../../images/diamond'
import BlockArrow from '../../../images/blockArrow'

import s from './GraphicDivider.module.sass'
import { getVideoUrl } from 'shared-functions/utils'

type ExtendedGraphicDividerType = GraphicDividerType & {
    site: string
}

function GraphicDivider({ angleTitlesAndIcons, columns, site }: ExtendedGraphicDividerType) {
    return (
        <section className={cn(s.GraphicDivider, site && s[site], angleTitlesAndIcons && s.AngleTitlesAndIcons)}>
            <div className={s.Title}>{Diamond}</div>
            <div className={cn(s.Cont, 'container')}>
                {columns?.map((column: any, index) => {
                    const { title, video, videoFile, image } = column

                    const videoUrl = getVideoUrl(videoFile, video)

                    return (
                        <div className={s.Column} key={index}>
                            {videoUrl && (
                                <div className={s.Video}>
                                    <video
                                        className={s.Video}
                                        autoPlay
                                        loop
                                        muted
                                        playsInline
                                        src={videoUrl}
                                    />
                                </div>
                            )}
                            {image && !videoUrl && (
                                <div className={s.Image}>
                                    <ImageBox image={image} alt={title || ''} width={500} height={500} />
                                </div>
                            )}
                            {BlockArrow}
                            {title && <h3 dangerouslySetInnerHTML={{ __html: title }} />}
                        </div>
                    )
                })}
            </div>
        </section>
    )
}

export default GraphicDivider
